import React, { useState } from 'react'
import './WeatherApp.css'

import search_icon from '../Assets/search.png'
import snow_icon from '../Assets/snow.png'
import wind_icon from '../Assets/wind.png'
import clear_icon from '../Assets/clear.png'
import cloud_icon from '../Assets/cloud.png'
import drizzle_icon from '../Assets/drizzle.png'
import humidity_icon from '../Assets/humidity.png'
import rain_icon from '../Assets/rain.png'
import night_icon from '../Assets/clear-night.png'


function WeatherApp() {
    let api_key = "47f1e9e2e1268cf05640789040c9b899"

    const [wicon, setWicon] = useState(cloud_icon)

    const search = async () => {
        const element = document.getElementsByClassName("cityInput")
        if (element[0].value === "") {
            return 0
        }
        let url = `https://api.openweathermap.org/data/2.5/weather?q=${element[0].value}&units=Metric&appid=${api_key}`

        let response = await fetch(url)
        let data = await response.json()
        const humidity = document.getElementsByClassName("humidity-percent")
        const wind = document.getElementsByClassName("wind-rate")
        const temp = document.getElementsByClassName("weather-temp")
        const location = document.getElementsByClassName("weather-location")

        humidity[0].innerHTML = data.main.humidity + " %"
        wind[0].innerHTML = data.wind.speed + " m/sec"
        temp[0].innerHTML = Math.floor(data.main.temp) + "°c" //(Alt + 0176) for degree symbol;
        location[0].innerHTML = data.name + ", " + data.sys.country

        if (data.weather[0].icon === "01d") {
            setWicon(clear_icon)
        }
        // else if (data.weather[0].icon === "01n") {
        //     setWicon(night_icon)
        // }
        else if (data.weather[0].icon === "02d" || data.weather[0].icon === "02n") {
            setWicon(cloud_icon)
        }
        else if (data.weather[0].icon === "03d" || data.weather[0].icon === "03n") {
            setWicon(drizzle_icon)
        }
        else if (data.weather[0].icon === "04d" || data.weather[0].icon === "04n") {
            setWicon(drizzle_icon)
        }
        else if (data.weather[0].icon === "09d" || data.weather[0].icon === "09n") {
            setWicon(rain_icon)
        }
        else if (data.weather[0].icon === "10d" || data.weather[0].icon === "10n") {
            setWicon(rain_icon)
        }
        else if (data.weather[0].icon === "13d" || data.weather[0].icon === "13n") {
            setWicon(snow_icon)
        }
        else {
            setWicon(night_icon)
        }
    }

    return (
        <div className='container'>
            <div className='top-bar'>
                <input type='text' className='cityInput' placeholder='Search'></input>
                <div className='search-icon' onClick={() => { search() } }>
                    <img src={search_icon} alt="" />
                </div>
            </div>
            <div className='weather_image'>
                <img src={wicon} alt='' />
            </div>
            <div className='weather-temp'>32.21 °c</div>
            <div className='weather-location'>London</div>
            <div className='data-container'>
                <div className='element'>
                    <img src={humidity_icon} alt="" className='icon' />
                    <div className='data'>
                        <div className='humidity-percent'>64% </div>
                        <div className='text'>Humidity </div>
                    </div>
                </div>
                <div className='element'>
                    <img src={wind_icon} alt="" className='icon' />
                    <div className='data'>
                        <div className='wind-rate'>18 km/hr </div>
                        <div className='text'>Wind Speed</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WeatherApp